import React from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "@mui/material";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import CallSharpIcon from "@mui/icons-material/CallSharp";
import VideocamSharpIcon from "@mui/icons-material/VideocamSharp";
import PersonSharpIcon from "@mui/icons-material/PersonSharp";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import KeyboardArrowUpSharpIcon from "@mui/icons-material/KeyboardArrowUpSharp";
import KeyboardArrowDownSharpIcon from "@mui/icons-material/KeyboardArrowDownSharp";
import MessageInteraction from "./MessageInteraction";
import { useTranslation } from "react-i18next";
import { isChatPinned } from "../../Services/apiService";

const ChatHeader = ({
  chatInfo,
  activeConversation,
  archiveMessage,
  getArchivedList,
  getChatList,
  getMessageList,
  setChatList,
  msgId,
  getUserImage,
  handleImageError,
  showSearch,
  onToggleSearch,
  searchQuery,
  onSearchQueryChange,
  onSearchClose,
  searchMatchCount,
  onSearchPrev,
  onSearchNext,
  showUserDetails,
  onToggleUserDetails,
  phoneNumber,
}) => {
  const { t } = useTranslation();

  if (!chatInfo?.toUserUid) return null;

  const isOnline =
    activeConversation?.chatInfo?.toUserIsOnline === true ||
    chatInfo?.toUserIsOnline === true;

  const handleCall = () => {
    if (phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    }
  };

  return (
    <>
      <div className="username-header d-flex justify-content-between align-items-center">
        <Link to={`/User/${chatInfo.toUserUid}`} className="chat-header-profile-link">
          <div className="chatbox-left-cont d-flex align-items-center">
            <div className="chat-header-avatar-wrap me-2">
              <img
                src={getUserImage(chatInfo?.toUserImage)}
                onError={handleImageError}
                alt={chatInfo?.toUserFullName || ""}
              />
              {isOnline ? <span className="chat-header-online-dot" aria-hidden="true" /> : null}
            </div>
            <div className="chat-header-user-meta">
              <div className="chat-box-username f-16 f-600">
                {chatInfo?.toUserFullName}
              </div>
              <span className="chat-header-status f-12 f-400">
                {isOnline
                  ? t("Notifications.Online")
                  : t("Notifications.Offline")}
              </span>
            </div>
          </div>
        </Link>

        <div className="chat-header-actions d-flex align-items-center">
          <Tooltip title={t("Notifications.Search in chat")} arrow>
            <button
              type="button"
              className={`chat-header-action-btn${showSearch ? " active" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                onToggleSearch();
              }}
              aria-label={t("Notifications.Search in chat")}
            >
              <SearchSharpIcon className="material-symbols-sharp" />
            </button>
          </Tooltip>

          {/* <Tooltip
            title={
              phoneNumber
                ? t("Notifications.Voice call")
                : t("Notifications.Voice call not available")
            }
            arrow
          >
            <button
              type="button"
              className="chat-header-action-btn"
              onClick={(e) => {
                e.stopPropagation();
                handleCall();
              }}
              disabled={!phoneNumber}
              aria-label={t("Notifications.Voice call")}
            >
              <CallSharpIcon className="material-symbols-sharp" />
            </button>
          </Tooltip>

          <Tooltip title={t("Notifications.Video call not available")} arrow>
            <button
              type="button"
              className="chat-header-action-btn"
              disabled
              aria-label={t("Notifications.Video call")}
            >
              <VideocamSharpIcon className="material-symbols-sharp" />
            </button>
          </Tooltip> */}

          <Tooltip title={t("Notifications.Contact info")} arrow>
            <button
              type="button"
              className={`chat-header-action-btn${showUserDetails ? " active" : ""}`}
              onClick={(e) => {
                e.stopPropagation();
                onToggleUserDetails();
              }}
              aria-label={t("Notifications.Contact info")}
            >
              <PersonSharpIcon className="material-symbols-sharp" />
            </button>
          </Tooltip>

          <div
            className="menu-list-icon"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <MessageInteraction
              variant="header"
              isPined={isChatPinned(activeConversation)}
              getChatList={getChatList}
              archiveMessage={archiveMessage}
              usermsgId={msgId || chatInfo?.msgID}
              msgId={msgId || chatInfo?.msgID}
              UserId={chatInfo?.toUserUid}
              toUserUId={chatInfo?.toUserUid}
              getArchivedList={getArchivedList}
              getMessageList={getMessageList}
              setChatList={setChatList}
            />
          </div>
        </div>
      </div>

      {showSearch ? (
        <div className="chat-search-bar d-flex align-items-center px-3 py-2">
          <SearchSharpIcon className="material-symbols-sharp me-2" />
          <input
            type="text"
            className="chat-search-input flex-grow-1"
            placeholder={t("Notifications.Search in chat")}
            value={searchQuery}
            onChange={(e) => onSearchQueryChange(e.target.value)}
            autoFocus
          />
          {searchQuery ? (
            <span className="chat-search-count f-12 me-2">
              {searchMatchCount > 0
                ? `${searchMatchCount} ${t("Notifications.Results")}`
                : t("Notifications.No results")}
            </span>
          ) : null}
          {searchMatchCount > 0 ? (
            <>
              <button
                type="button"
                className="chat-header-action-btn"
                onClick={onSearchPrev}
                aria-label="Previous match"
              >
                <KeyboardArrowUpSharpIcon className="material-symbols-sharp" />
              </button>
              <button
                type="button"
                className="chat-header-action-btn"
                onClick={onSearchNext}
                aria-label="Next match"
              >
                <KeyboardArrowDownSharpIcon className="material-symbols-sharp" />
              </button>
            </>
          ) : null}
          <button
            type="button"
            className="chat-header-action-btn"
            onClick={onSearchClose}
            aria-label="Close search"
          >
            <CloseSharpIcon className="material-symbols-sharp" />
          </button>
        </div>
      ) : null}
    </>
  );
};

export default ChatHeader;
